import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0" }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M17.627 15.826a1.272 1.272 0 1 1-1.8 1.801L12 13.801l-3.826 3.826a1.27 1.27 0 0 1-1.8 0 1.27 1.27 0 0 1 0-1.8L10.2 12 6.373 8.174a1.272 1.272 0 1 1 1.8-1.8L12 10.2l3.826-3.827a1.272 1.272 0 1 1 1.8 1.8L13.8 12z"
    }, null, -1)
  ]))]))
}
export default { render: render }